<template>
    <div>
        <cmtbox :id="$route.params.id"></cmtbox>
    </div>
</template>
<script>
import cmtbox from '../subcoment/comment.vue'
export default {
    components:{
        cmtbox
    }
}
</script>
<style lang="scss" scope>
    
</style>


// WEBPACK FOOTER //
// src/components/goods/GoodsComment.vue